import { ArrowSvg } from '@icons/ArrowSvg';
import { Checkbox } from 'primereact/checkbox';
import { FaTrash } from 'react-icons/fa';
import styled from 'styled-components';
import React from 'react';

export const ActionPanelWrapper = styled.div`
  background: #e7ebee;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'DM Sans', sans-serif;
`;
export const ActionPanelLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const ActionButton = styled.button<{ disabled?: boolean }>`
  margin: 0 8px;
  color: #ff6b00;
  background: none;
  border: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  padding: 0;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: ${props => (props.disabled ? 0.5 : 0.8)};
  }
`;
export const ArrowIcon = styled.span`
  display: inline-flex;
  align-items: center;
  margin: 0 8px 0 8px;
  color: #b0b0b0;
  font-size: 18px;
  svg {
    display: block;
  }
`;
export const VerticalDivider = styled.span`
  display: inline-block;
  width: 2px;
  height: 16px;
  background: #b0b0b0;
  margin: 0 8px;
  vertical-align: middle;
`;

interface ActionPanelProps {
  allSelected: boolean;
  selectedCount: number;
  handleSelectAllChange: (checked: boolean) => void;
  handleMassEdit: () => void;
  handleShareSelected: () => void;
  handleCopySelected: () => void;
  enableCopyDocument: boolean;
  handleDownloadZip?: () => void;
  enableDownloadZip?: boolean;
  downloadZipBusy?: boolean;
  handleDeleteSelected: () => void;
  disabled: boolean;
  disabledDelete?: boolean;
  disabledMassAction?: boolean;
  doNotShare: boolean;
  tr: (key: string, fallback: string) => string;
}

export const ActionPanel: React.FC<ActionPanelProps> = ({
  allSelected,
  selectedCount,
  handleSelectAllChange,
  handleMassEdit,
  handleShareSelected,
  handleCopySelected,
  enableCopyDocument,
  handleDownloadZip,
  enableDownloadZip = false,
  downloadZipBusy = false,
  handleDeleteSelected,
  disabled,
                                                          disabledDelete,
                                                          disabledMassAction,
  doNotShare,
  tr,
}) => {
  return (
    <ActionPanelWrapper>
      <ActionPanelLeft>
        <Checkbox
          checked={allSelected}
          onChange={e => handleSelectAllChange(e.checked as boolean)}
          style={{ marginRight: 8 }}
          disabled={disabled && !enableDownloadZip}
        />
        <span>
          {selectedCount} {tr('AttachementComponent.selected', 'vybraných')}
        </span>
        <ArrowIcon>
          <ArrowSvg />
        </ArrowIcon>

        <ActionButton onClick={handleDeleteSelected} disabled={selectedCount === 0 || disabled || disabledDelete}>
          <FaTrash />
        </ActionButton>

        <VerticalDivider />

        <ActionButton onClick={handleMassEdit} disabled={selectedCount === 0 || disabled || disabledMassAction}>
          {tr(`AttachementComponent.massEdit`, `Hromadná editace`)}
        </ActionButton>

        <VerticalDivider />

        <ActionButton onClick={handleShareSelected} disabled={selectedCount === 0 || disabled || doNotShare}>
          {tr(`AttachementComponent.shareWithEmail`, `Share`)}
        </ActionButton>

        {enableCopyDocument && (
          <>
            <VerticalDivider />
            <ActionButton onClick={handleCopySelected} disabled={selectedCount === 0 || disabled}>
              {tr(`AttachementComponent.copyAttachments`, `Copy attachments`)}
            </ActionButton>
          </>
        )}

        {enableDownloadZip && (
          <>
            <VerticalDivider />
            <ActionButton onClick={handleDownloadZip} disabled={selectedCount === 0 || downloadZipBusy}>
              {tr(`AttachementComponent.downloadZip`, `Download`)}
            </ActionButton>
          </>
        )}
      </ActionPanelLeft>
    </ActionPanelWrapper>
  );
};
